import { Formik } from "formik";

import { addToast } from "@icg360/design-system";

import { MSSLink } from "components/common/link";
import { validatePasswordFormik } from "consts";
import { useKeystone } from "data/ss-data-hooks";
import { isError } from "data/ss-error";
import { logException, trackEvent } from "utils";

import ChangePasswordModalForm from "./change-password-modal-form";

const changePasswordError = (
  <>
    An error occurred. Please try again, or{" "}
    <MSSLink to="/request-reset">reset your password</MSSLink> via email.
  </>
);

const initialValues = {
  password: "",
  passwordConfirmation: "",
};

export type ChangePasswordModalSchema = typeof initialValues;

type ChangePasswordModalProps = {
  show: boolean;
  handleClose: () => void;
  userId: string;
};

const ChangePasswordModal = ({
  show,
  handleClose,
  userId,
}: ChangePasswordModalProps) => {
  const keystone = useKeystone();

  const handleSubmit = async (
    { password },
    { setSubmitting, setStatus, resetForm }
  ) => {
    try {
      setSubmitting(true);
      setStatus(null);

      const req = await keystone.resetPassword(userId, password);

      if (!isError(req)) {
        trackEvent("Update password - reset complete");
        addToast("Password has been successfully updated.", { icon: true });
        handleClose();
        resetForm();
      } else {
        setStatus(changePasswordError);
        trackEvent("Error Displayed (Change Password)", {
          error: req.message,
        });
      }

      setSubmitting(false);
    } catch (err) {
      logException(err);
      setStatus(changePasswordError);
      trackEvent("Error Displayed (Change Password)", {
        error: err,
      });
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validate={validatePasswordFormik}
      enableReinitialize
    >
      <ChangePasswordModalForm show={show} handleClose={handleClose} />
    </Formik>
  );
};

export default ChangePasswordModal;
